import { Endpoints } from '../interfaces';
import { ENV } from './env';

export const endpoints: Endpoints = {
  PortalApiUrl: ENV.PORTAL_API_URL,
  ARSApiUrl: ENV.ARS_API_URL,
  EFTApiUrl: ENV.EFT_API_URL,
  CPSApiUrl: ENV.CPS_API_URL,
  DLCApiUrl: ENV.DLC_API_URL,
  tokenRefresh: 'auth/refresh',
  authenticate: 'auth/authenticate',
  securityCode: 'auth/authenticate2',
  user: 'auth/user',
  logout: 'auth/logout',
  secondFactorSelect: 'auth/second-factor-select',
  authenticatePasswordReset: 'auth/authenticate-password-reset',
  authenticatePasswordChange: 'auth/authenticate-change-password',
  versionInformation: 'versionInformation',
  version: 'version',
  upload: 'payments/upload',
  uploadedFiles: 'payments/upload/status',
  resetPassword: 'reset-password',
  userAccountSummaries: 'useraccountsummaries',
  balanceHistory: 'balance-history',
  currencyAccounts: 'currency-accounts',
  currencies: 'currencies',
  byGroupSummary: 'by-group-summary',
  banks: 'banks',
  byCountrySummary: 'by-country-summary',
  orders: 'orders',
  saveAndSubmit: 'save-and-submit',
  restore: 'restore',
  export: 'export',
  accounts: 'administration/accounts',
  portalAccounts: 'accounts/findAll',
  applications: 'administration/users/applications',
  mbsModules: 'administration/users/mbsModules',
  settings: 'administration/users/settings',
  gridSettings: 'administration/users/settings/grid',
  secondFactorAuthTypes: 'administration/users/secondFactorTypes',
  unlockUser: 'administration/users/unlock',
  switchActivation: 'administration/users/switchActivation',
  usersResetPassword: 'administration/users/resetPassword',
  users: 'administration/users/findAll',
  getUser: 'administration/users',
  deleteUser: 'administration/users',
  addUser: 'administration/users',
  userGroups: 'administration/userGroups',
  getAllUserGroups: 'administration/userGroups/findAll',
  validateUsername: 'administration/users/validateUsername',
  validateGroupName: 'administration/userGroups/validateGroupName',
  validateOwnerDisplayName: 'administration/owners/validate/displayName',
  validateBic: 'administration/banks/validate/bic',
  validateBankCode: 'administration/banks/validate/bankCode',
  validateBankDisplayName: 'administration/banks/validate/displayName',
  validateTemplateDisplayName: 'administration/templates/validate/displayName',
  requestSecondFactor: 'user/change-password/request-second-factor',
  authenticateSecondFactor: 'user/change-password/authenticate-second-factor',
  changePassword: 'user/change-password/change-password',
  profile: 'profile',
  generateReport: 'get-pdf',
  administration: '/administration',
  oldEditor: '/#!/app/order/editor/',
  gridConfig: 'grid-config',
  clients: 'administration/clients',
  clientEditor: '/#!/app/administration/client/editor',
  dbPool: 'db-pool-state',
  threadDump: 'thread-dump',
  clientLogs: 'clientLogs',
  templates: 'administration/templates/relevant',
  fromTemplates: '/from-templates',
  templatesOverview: 'administration/templates',
  getCSClient: 'administration/clients/csClient',
  arsUsers: '/users',
  findAll: '/findAll',
  paymentsTransactions: '/transactions',
  transactions: '/transactions/values',
  accountsSearchables: '/useraccountsearchables/useraccounts/accounts',
  searchableItems: '/useraccountsearchables/all-items',
  transactionsTypes: '/useraccountsearchables/transactiontypes',
  transactionsIndividualDownloads: '/transactionsindividualdownload',
  impersonationUsers: 'users',
  impersonation: 'impersonation',
  impersonate: 'impersonate',
  userAccReports: '/useraccountreports',
  transactionsDownloads: '/transactionsdownload',
  intradaysDownloads: '/intradaysdownload',
  manualEntrysDownloads: '/manualentrysdownload',
  change: 'change',
  exportClientSide: 'exportClientSide',
  exportZip: 'exportZip',
  downtimeNotification: 'downtimeNotification',
  active: 'active',
  staticData: 'staticdata',
  documents: 'document',
  downloader: '/downloader',
  activate: '/activate',
  delete: '/delete',
  download: '/getDocument',
  downloadZip: '/zip',
  uploadFidesDocument: '/document/uploadFidesDocument',
  findAllFidesDocuments: '/document/findAllFidesDocuments',
  getDocument: '/document/getDocument',
  dlcStaticdata: '/staticdata/',
  getPublicDocument: '/document/getPublicDocument',
  resetAuthenticator: 'auth/reset',
  dtNotificationOverlapValidation: 'downtimeNotification/overlaps',
  pendingPaymentsApprovals: 'administration/twomanrules',
  pendingLiquidityMgmtApprovals: 'twomanrules/findAll',
  pendingLiquidityMgmtApprovalDetails: 'twomanrules',
  pendingLiquidityMgmtApprovalDetailsChanges: 'twomanrules/findAllChanges',
  pendingApprovals: 'administration/twomanrules',
  transactionGroup: 'transactions/transaction-group',
  transactionGroups: 'transaction-groups',
  bankList: 'administration/banks',
  generateTransaction: '/transactions/generate',
  generateTransactionGroups: '/transaction-groups/generate',
  findPage: '/find-page',
  owners: 'administration/owners',
  generateFromTemplate: 'orders/generateFromId',
  fromTemplateValues: 'orders/fromTemplateValues',
  getXml: 'get-xml',
  dashboardConfig: '/dashboard-config',
  regulatoryReporting: 'regulatory-reporting',
  structuredRemittanceInfos: 'structured-remittance-infos',
};
